import { MultiselectItem } from '@ui/aos-lib';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { FilterModel } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { CommunicationStatus, DeviceListingFieldName } from '../../components/devices.models';

const COMMUNICATION_STATUS_ITEMS: MultiselectItem[] = [
  { text: TranslateRegistry.get.FILTER.COMMUNICATION_STATUS.ONLINE, value: CommunicationStatus.Online },
  { text: TranslateRegistry.get.FILTER.COMMUNICATION_STATUS.OFFLINE, value: CommunicationStatus.Offline }
];

export const COMMUNICATION_STATUS: FilterModel = {
  title: TranslateRegistry.get.FILTER.TITLE.COMMUNICATION_STATUS,
  items: COMMUNICATION_STATUS_ITEMS,
  selected: COMMUNICATION_STATUS_ITEMS,
  filterType: DeviceListingFieldName.DcuCommunicationStatus,
  isMultiselect: true,
  isNonSortable: true,
  width: 160
};
